<template>
    <footer-basic></footer-basic>
</template>

<script>
import FooterBasic from '@/components/ThemeMDB/home/partials/FooterBasic';
 export default {
    name: 'Footer',
    components:{
        FooterBasic
    }
    
};
</script>
